// extracted by mini-css-extract-plugin
module.exports = {"sharingOptions":"Share_sharingOptions__tI6mi","inline":"Share_inline__VNz8E","actions":"Share_actions__AQ_70","action":"Share_action__YLyAM"};